import { render, staticRenderFns } from "./the-header.vue?vue&type=template&id=7cb00019&scoped=true&"
import script from "./the-header.vue?vue&type=script&lang=ts&"
export * from "./the-header.vue?vue&type=script&lang=ts&"
import style0 from "./the-header.vue?vue&type=style&index=0&id=7cb00019&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb00019",
  null
  
)

export default component.exports